
const styles = theme => ({
    WrapperHome: {
        minHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        [theme.breakpoints.down('xs')]: {
            minHeight: '100%',
            height: 'auto',
        }
    },
    containerFlex1:{
        flex:1,
        overflowY: 'hidden',
        overflowX: 'hidden',
        WebkitOverflowScrolling: 'touch',
    },
    WrapperButton: {
        display: 'flex',
        flexDirection: 'row',
        '& div + div':{
            marginLeft: 24,
        },
        [theme.breakpoints.down('xs')]: {
          flexWrap: 'wrap',
          '& div + div':{
              marginLeft: 0,
              marginTop: 24,
          },
        },
    },
    paddingContent: {
        padding: '8px'
    }
})

export default styles;
